var testKey = '__test_storage_support__';

export var testStorageSupport = function testStorageSupport() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'local';

  try {
    var storage = window[type + 'Storage'];
    storage.setItem(testKey, true);
    storage.getItem(testKey);
    storage.removeItem(testKey);
    return true;
  } catch (err) {
    return false;
  }
};

export var createStorage = function createStorage() {
  var memoryStorage = Object.defineProperties({}, {
    getItem: {
      value: function value(key) {
        return memoryStorage[key] || null;
      }
    },
    setItem: {
      value: function value(key, _value) {
        try {
          memoryStorage[key] = String(_value);
        } catch (err) {}
      }
    },
    removeItem: {
      value: function value(key) {
        delete memoryStorage[key];
      }
    },
    clear: {
      value: function value() {
        Object.keys(memoryStorage).forEach(memoryStorage.removeItem);
      }
    },
    key: {
      value: function value(index) {
        return Object.keys(memoryStorage)[index] || null;
      }
    },
    length: {
      get: function get() {
        return Object.keys(memoryStorage).length;
      }
    }
  });
  return memoryStorage;
};

export default /*#__PURE__*/createStorage();


//////////////////
// WEBPACK FOOTER
// ./node_modules/memory-web-storage/es/index.js
// module id = 527
// module chunks = 0